import React from 'react';
import { Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { hasCookie, setCookie } from 'services/actions/cookies_actions';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import createTrack from 'services/actions/tracker_actions';
import { Container } from './styles';

interface ConlicitasegModalBetaTesterProps {
  show: boolean;
  onClose: () => void;
}

const LEGACY_COOKIE = 'ConlicitasegModalBetaTester';

export const conlicitasegModalCookie = (userId: number) => `${LEGACY_COOKIE}_${userId}`;

export const hasDismissedConlicitasegModal = (userId: number) =>
  hasCookie(conlicitasegModalCookie(userId)) || hasCookie(LEGACY_COOKIE);

const ConlicitasegModalBetaTester: React.FC<ConlicitasegModalBetaTesterProps> = ({
  show,
  onClose,
}) => {
  const history = useHistory();
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const handleClose = () => {
    setCookie(conlicitasegModalCookie(profile.id), true);
    createTrack('ConlicitaSeg - Fechou modal', {
      fonte: 'Modal Beta Tester',
    });
    onClose();
  };

  const handleStartNow = () => {
    setCookie(conlicitasegModalCookie(profile.id), true);
    createTrack('ConlicitaSeg - Clicou no botão conhecer ConlicitaSeg', {
      fonte: 'Modal Beta Tester',
    });
    history.push('/conlicitaseg');
    onClose();
  };

  const handleRemindLater = () => {
    createTrack('ConlicitaSeg - Lembrar mais tarde', {
      fonte: 'Modal Beta Tester',
    });
    onClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg" backdrop="static">
      <Container>
        <button type="button" className="close-button" onClick={handleClose} aria-label="Fechar">
          <i className="material-icons">close</i>
          <span className="ml-2">Fechar</span>
        </button>

        <div className="modal-content-wrapper">
          <h2 className="title">Olá, {profile.name}!</h2>

          <p className="subtitle">
            Convidamos você a conhecer nossa mais nova ferramenta para emissão online de Seguro
            Garantia, o ConlicitaSeg.
          </p>

          <p className="description">
            Agora, sempre que precisar de ajuda com garantia de proposta ou garantia contratual,
            você poderá obter facilmente cotações das nossas seguradoras parceiras e escolher a mais
            adequada à sua necessidade.
          </p>

          <div className="btn-group-vertical" role="group">
            <button
              type="button"
              className="btn btn-primary btn-lg btn-start"
              onClick={handleStartNow}
            >
              Conheça o ConlicitaSeg agora mesmo
            </button>
            <button
              type="button"
              className="btn btn-link link-primary text-decoration-none"
              onClick={handleRemindLater}
            >
              Lembre-me mais tarde
            </button>
          </div>
        </div>
      </Container>
    </Modal>
  );
};

export default ConlicitasegModalBetaTester;
